import { ModalWindow } from '@components/Modal/ModalWindow';
import { ModalWindowContent } from '@components/Modal/ModalWindowContent';
import { ModalWindowTitle } from '@components/Modal/ModalWindowTitle';
import { TableWrapper } from '@components/Table/TableWrapper';
import { useData } from '@hooks/useData';
import useLoading from '@hooks/useLoading';
import useMessage from '@hooks/useMessage';
import { IModalWindow } from '@hooks/useModalWindow';
import { IRemessaFatura } from '@model/RemessaFatura';
import { IRemessaFaturaFilter, useRemessaService } from '@services/RemessaService';
import React from 'react';
import { RemessaDetalheTable } from './RemessaDetalheTable';

export type RemessaDetalheModalProps = {
    remessaId: number
    modal: IModalWindow
}

export function RemessaDetalheModal ({ remessaId, modal }: RemessaDetalheModalProps) {
    const loading = useLoading();
    const message = useMessage();

    const remessaService = useRemessaService();

    const data = useData<IRemessaFatura, IRemessaFaturaFilter>({
        filter: {
        }
    })

    const handleEnter = React.useCallback(() => {
        data.filter.reset();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    React.useEffect(() => {
        if (!loading.isLoading) {
            const filterValues = data.filter.getInputValues();

            loading.start();
            remessaService.listarItens(remessaId, filterValues)
                .then(data.handleDataResponse)
                .catch(message.showException)
                .finally(loading.stop);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data.requestedData, remessaId])

    return (
        <ModalWindow
            modal={modal}
            disabled={loading.isLoading}
            size="md"
            TransitionProps={{
                onEnter: handleEnter
            }}
        >
            <ModalWindowTitle
                title={`Itens da Remessa ${remessaId}`}
            />

            <ModalWindowContent>
                <TableWrapper>
                    <RemessaDetalheTable 
                        data={data}
                    />
                </TableWrapper>
            </ModalWindowContent>
        </ModalWindow>
    )
}